
<Carte
  :content="jel_isCarteLarge(content) ? contentCarte : content"
  :class="'nb-colonne-' + content.nbColonne"
>
  <b-container
    class="h-100"
    :class="[
      { 'p-0': content.nbColonne == 2 },
      jel_isCarteLarge(content) ? 'py-1 carte-large' : { 'py-0': content.titre },
    ]"
  >
    <div class="m-0 h-100" :class="typeCarteListe">
      <b-col v-if="content.titre" class="m-0 p-0 d-flex titre-carte">
        <b-link
          v-bind="jel_getLienBinding(content.lien)"
          class="graphik_black w-100 d-flex align-items-center bordure-titre"
        >
          {{ content.titre }}
          <b-icon
            v-if="!jel_getLienBinding(content.lien).disabled"
            scale="0.7"
            icon="chevron-right"
            class="d-none d-xl-flex"
          />
        </b-link>
      </b-col>
      <b-col
        v-for="(itemElement, index) in getElements"
        :key="index"
        :class="content.nbColonne == 2 ? 'liste-2-colonnes' : 'liste-1-colonne px-0'"
      >
        <slot name="element" :itemElement="itemElement" :elementPremiereLigne="index < 2"></slot>
      </b-col>
    </div>
  </b-container>
</Carte>
